import { ICG2Guidelines } from '@fortem-monorepo/web-sdk'

import { formatNumber, getNumberTypeSuffix } from '@/utilities/format'

export const formatGuidelineNumber = (
  value: number,
  thresholdType: ICG2Guidelines.ThresholdType,
) => {
  const suffix = getNumberTypeSuffix(thresholdType)

  return formatNumber(value, {
    roundingMode: 'truncate',
    suffix,
  })
}
